import { useEffect, useState, useMemo } from 'react';
import { useNavigate } from 'react-router';
import { useApp } from 'contexts/app';
import CustomerService from 'services/customer';
import StoreSettingService from 'services/store_setting';
import _ from 'lodash';

const service = new CustomerService();
const storeSettingService = new StoreSettingService();

export const useInfoModal = ({ id, open, onClose, onSave }) => {
  const navigate = useNavigate();
  const { showLoading, downloadPDF ,printPDF} = useApp();

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [customer, setCustomer] = useState({});
  const [orders, setOrders] = useState([]);
  const [showCustomerEdit, setShowCustomerEdit] = useState(false);
  const [showCustomerLoginEdit, setShowCustomerLoginEdit] = useState(false);
  const [isAccountLoginMode, setIsAccountLoginMode] = useState(false);

  // Sync modal open state with prop
  useEffect(() => {
    if (isModalOpen !== open) {
      setIsModalOpen(open);
    }
  }, [open]);

  // Load login method when modal opens
  useEffect(() => {
    if (open) {
      loadLoginMethod();
    }
  }, [open]);

  // Load data when modal opens/closes
  useEffect(() => {
    if (!isModalOpen && open && onClose) {
      onClose();
    }
    if (isModalOpen) {
      loadData();
    }
  }, [isModalOpen]);

  const loadData = async () => {
    setCustomer({});
    setOrders([]);

    if (id) {
      try {
        const cus = await service.getByID(id);
        if (cus) {
          setCustomer(cus);
          const newOrder = _.orderBy(cus.orders, ['create_on'], ['desc']);
          setOrders(newOrder);
        }
      } catch (error) {
        console.error('Error loading customer data:', error);
      }
    }
  };

  const loadLoginMethod = async () => {
    try {
      const setting = await storeSettingService.getWebsiteSetting();
      setIsAccountLoginMode(setting?.login_method === 'account');
    } catch (error) {
      setIsAccountLoginMode(false);
    }
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const onCustomerSave = async () => {
    await loadData();
    if (onSave) {
      onSave();
    }
  };

  return {
    isModalOpen,
    customer,
    orders,
    showCustomerEdit,
    setShowCustomerEdit,
    showCustomerLoginEdit,
    setShowCustomerLoginEdit,
    isAccountLoginMode,
    handleCancel,
    onCustomerSave,
    navigate,
    showLoading,
    downloadPDF,
  };
};
